import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import QuienesSomos from './components/QuienesSomos';
import Diferencial from './components/Diferencial';
import Servicios from './components/Servicios';
import Trayectoria from './components/Trayectoria';
import CallToAction from './components/CallToAction';
import Contacto from './components/Contacto';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <QuienesSomos />
        <Diferencial />
        <CallToAction />
        <Trayectoria />
        <Servicios />
        <Contacto />
      </main>
      <Footer />
    </div>
  );
}

export default App;
